import PropTypes from 'prop-types';
import noop from 'lodash';
import React from 'react';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { messageTypes, messageTypeIconMapping } from './CMMessages.config';

const CMMessages = (props) => {
    const { type, title, subTitle } = props;
    return (
        <div className={dt(['pb-4', 'lg:px-4', 'font-open-sans'])}>
            <div className={dt(['text-center'])}>
                <Icon iconType="svg" width="16px" height="16px" viewBox="0 0 16 16">
                    {messageTypeIconMapping[type]}
                </Icon>
                <span
                    className={dt([
                        'text-gray-70',
                        'uppercase',
                        'text-sm',
                        'leading-5',
                        'font-semibold',
                        'ml-1.5',
                    ])}
                >
                    {title}
                </span>
            </div>
            <p className={dt(['text-gray-70', 'font-normal', 'text-xs', 'leading-4'])}>
                {subTitle}
            </p>
        </div>
    );
};
CMMessages.propTypes = {
    type: noop,
    title: PropTypes.string,
    subTitle: PropTypes.string,
};

CMMessages.defaultProps = {
    type: messageTypes?.error,
    title: '',
    subTitle: '',
};
export default CMMessages;
